import {
  ChartDataset,
  ChartStyle
} from "state/ui/editor/elements/ChartElement";
import {
  BandScale,
  LinearScale,
  PlotArea,
  formatTickLabel,
  xAxisLabelOffsetFor
} from "../chartScales";

interface Props {
  dataset: ChartDataset;
  style: ChartStyle;
  plot: PlotArea;
  x: BandScale;
  y: LinearScale;
  ticks: number[];
}

// Shared axis layer for vertical cartesian charts (line, area, column):
// horizontal gridlines, y-axis value ticks, and x-axis category labels. The
// labels sit outside the plot rectangle, so rendering this before the series
// (rather than after) is visually identical while keeping gridlines behind it.
// Bar charts use a rotated layout and render their own axes.
const CartesianAxes = ({ dataset, style, plot, x, y, ticks }: Props) => (
  <>
    {style.showGridlines &&
      ticks.map(tick => (
        <line
          key={`grid-${tick}`}
          x1={plot.left}
          x2={plot.left + plot.width}
          y1={y.scale(tick)}
          y2={y.scale(tick)}
          stroke="#E5E7EB"
          strokeWidth={1}
        />
      ))}

    {style.showAxes &&
      ticks.map(tick => (
        <text
          key={`y-${tick}`}
          x={plot.left - 6}
          y={y.scale(tick)}
          fontSize={style.fontSize}
          fill={style.color}
          fontFamily={style.fontFamily}
          textAnchor="end"
          dominantBaseline="middle"
        >
          {formatTickLabel(tick)}
        </text>
      ))}

    {style.showAxes &&
      dataset.headers.map((header, colIndex) => (
        <text
          key={`x-${colIndex}`}
          x={x.scaleAt(colIndex) + x.bandwidth / 2}
          y={plot.top + plot.height + xAxisLabelOffsetFor(style.fontSize)}
          fontSize={style.fontSize}
          fill={style.color}
          fontFamily={style.fontFamily}
          textAnchor="middle"
        >
          {header}
        </text>
      ))}
  </>
);

export default CartesianAxes;
